import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env';

@Pipe({
  name: 'avatarUrl'
})
export class AvatarUrlPipe implements PipeTransform {
  transform(fileName: string | undefined): string {
    if (!fileName) {
      return '';
    }


    return `${environment.cdnPath}/avatar-bonus/${ fileName }`;
  }
}
